<template>
<div class="col backgroundForm">
    <div class="col col-md-10 offset-md-1">
        <h3 clas="col" align="center">Lectura de Nivel de Rio </h3>
        <h6 align="right"></h6>
        <div class="form-row">
            <div class="form-group col col-md-4 offset-md-2">
                <label for="list_lake">Rio/lago</label>
                <select name="lis_lake" id="list_lake" class="form-control" v-model="lake_select_aux" @change="mSelectRiver" v-html="option_river">
                    <!-- <optgroup label="Cerrrada">
                        <option v-for="lr in list_river" :key="lr.id" :value="lr">{{ lr.name_lake }} - {{ lr.cuenca }}</option>
                    </optgroup> -->

                </select>
            </div>
            <div class="form-group col col-md-4" v-if="list_sector.length > 0">
                <label for="list_lake">Sector</label>
                <select name="lis_lake" id="list_lake" class="form-control" v-model="sector_select" @change="mSelectSector">
                    <option v-for="slr in list_sector" :key="slr.id_sector" :value="slr">{{ slr.sector }} </option>
                </select>
            </div>
        </div>
        <div v-if="sector_select.id_sector > 0">
            <div class="form-row">
                <div class="form-group col col-md-8 offset-md-2">
                    <label for="descripcion_lake">Descripcion</label>
                    <input type="text" readonly class="form-control-plaintext" id="description_sector" v-model="sector_select.description">
                </div>
            </div>

            <div class="form-row">
                <div class="form-group col col-md-3">
                    <label for="typeLevel">Tipo de Lectura</label>
                    <select name="type_read" id="type_read" class="form-control" v-model="read_lake.type_read">
                        <option value="SNB">Sobre Nivel Barranco</option>
                        <option value="BNB">Bajo Nivel Barranco</option>
                    </select>
                </div>
                <div class="form-group col col-md-2">
                    <label for="typeLevel">Dato (mts.)</label>
                    <input type="number" name="dataread" id="dataread" class="form-control" autocomplete="off" v-model="read_lake.data_read">
                </div>
                <div class="form-group col col-md-3">
                    <label for="typeLevel">Fecha</label>
                    <datetime v-model="read_lake.date_read" type="date" :phrases="{ok: 'Aceptar', cancel: 'Cerrar'}" input-class="form-control" :format="{year:'numeric', month:'long', day:'numeric'}" placeholder="Seleccione Fecha" title="Fecha de Inicio" value-zone="America/La_Paz"></datetime>
                </div>
                <div class="form-group col col-md-1">
                    <label for="typeLevel">Hora</label>
                    <datetime v-model="time_read_aux" type="time" :phrases="{ok: 'Aceptar', cancel: 'Cerrar'}" input-class="form-control" placeholder="Hora" title="Hora de Inicio" value-zone="America/La_Paz"></datetime>
                </div>
                <div class="form-group col col-md-2">
                    <label for="estado_clima">Clima</label>
                    <select name="climate" class="form-control" id="climate" v-model="read_lake.climate">
                        <option v-for="lc in list_clima" :value="lc.id" :key="lc.id">{{ lc.detail }}</option>
                    </select>
                </div>
            </div>

            <button class="btn btn-outline-danger col-12 col-md-4 offset-md-4" :disabled="btn_r_read" @click="saveRead">
                        <font-awesome-icon icon="save" size="3x" />
            </button>


        </div>

    </div>
</div>
</template>

<script>

import Vue from 'vue'
  import axios from 'axios'
  const qs= require('qs');

  import modalLoading from '../modal/modalLoading';


export default {
    name:'read-river',
    data(){
        return {
            btn_r_read:false,
            list_river:[],
            option_river:null,
            list_sector:[],
            lake_select:{id:0},
            lake_select_aux:0,
            sector_select:{id_sector:0},
            read_lake:{
                id_captain:0,
                sector_id:0,
                data_read:null,
                date_read:null,
                hour_read:null,
                climate:null,
                type_read:null
            },
            list_clima:[],
            time_read_aux:null
        }
    },
    mounted(){
        this.mChargeInit();
    },
    methods:{
        mValidateRegRead(){
            if(this.read_lake.sector_id===0){
                toastr.error(`Debe seleccionar un rio o lago para su lectura`);
                return false;
            }

            if(this.read_lake.type_read===null){
                toastr.error(`Debe seleccionar entre Bajo Nivel Barranco o Sobre Nivel Barranco`);
                return false;
            }

            if(this.read_lake.data_read===null || this.read_lake.data_read < 0){
                toastr.error(`Indique el dato de nivel de lectura`);
                return false;
            }


            let adi=this.read_lake.date_read.split('T');
            this.read_lake.date_read=adi[0];

            if( this.read_lake.date_read === null || !(this.read_lake.date_read.length === 10) ){
                toastr.error('La fecha de Inicio es incorrecta', 'Error');
                return false;
            }
            try {
                let ah=this.time_read_aux.split('T');
                let ah2=ah[1].split(':');
                this.read_lake.hour_read=ah2[0]+ah2[1];    
            } catch (error) {
                console.log(error)
            }
            
            // console.log(this.dts_ordop.time_init);
            if( this.read_lake.hour_read === null ||!(this.read_lake.hour_read.length >= 3 ) || !(this.read_lake.hour_read.length <= 4)  || this.read_lake.hour_read >=2400 ){
                toastr.error('La Hora de Inicio es incorrecta', 'Error');
                return false;
            }

            if(this.read_lake.climate === null){
                toastr.error(`Debe seleccionar un estado del clima`);
                return false;
            }
            return true;
        },
        saveRead(){
            if(this.mValidateRegRead()){
                // console.log('guardando la lectura de rio')
                let type_read_aux=this.read_lake.type_read === 'SNB' ? 'Sobre Nivel Barranco':'Bajo Nivel Barranco';
                let message = {
                    title: 'Registro de Lectura de Rio',
                    body: `¿Desea Registrar la lectura de <b>${this.read_lake.data_read} mts. ${type_read_aux}</b>?`
                }
                // let aid=id;
                let npr=new Promise((resolve, reject)=>{
                    this.$dialog
                    .confirm(message)
                    .then(function(dialog) {
                        resolve(true);          
                    })
                    .catch(function() {
                        resolve(false);
                    });
                });
                
                npr.then(async (msg)=>{
                    if(msg){
                        try {
                            this.read_lake.id_captain=this.cDtsUser.portId;
                            // console.log(this.cDtsUser);
                            // console.log(this.read_lake.id_captain)
                            // console.log(this.read_lake);
                            // let btn_send=document.getElementById(this.btn_r_ordop);
                            this.btn_r_read=true;
                            // console.log(`cerramos el ordop con id ${id}`);
                            // this.activeModal(this.id_modal_progress);
                            let r_river=await axios.post(`registerReadLake?api_token=${Vue.auth.getToken()}`,  qs.stringify(this.read_lake));
                            // console.log(r_river);
                            setTimeout(()=>{                                
                                if(r_river.data.status){
                                    toastr.success(r_river.data.respuesta, 'Exito');
                                    this.btn_r_read=false;
                                    this.mResetFormRead();
                                    // preguntamos si se cerrara el ordop para que no aparezca
                                    // limpiamos los campos en caso de no haberse limpiado
                                }else{
                                    toastr.warning(r_river.data.respuesta, 'Error');
                                }                                
                                // this.inactiveModal(this.id_modal_progress);
                            },1000)

                        }catch(err){
                            // console.log('no se va a cerrar el ordop');
                            setTimeout(()=>{
                                toastr.error('Ha ocurrido un error en el proceso de Registro de Lectura de Rio', 'Error LNR-02')
                                // this.inactiveModal(this.id_modal_progress);
                            }, 3000)
                        }
                    }else{
                        // console.log('No se cerro la ordop')
                        toastr.warning('No se ha Registrado la Lectura', 'Atencion!!')
                        // console.log(this.s_pro_ordop);
                    }
                })
            }            
        },
        mResetFormRead(){
            this.read_lake.data_read=null,
            this.read_lake.date_read=null,
            this.read_lake.hour_read=null,
            this.read_lake.climate=null,
            this.read_lake.type_read=null
            
        },
        async mChargeInit(){
            this.list_clima=[];
            let listRiver=await axios.get(`getListLake?api_token=${Vue.auth.getToken()}`);
            // console.log(listRiver);
            let listcl=await axios.get(`globals/climate?api_token=${Vue.auth.getToken()}`);

            // aqui armamos el option con option group
            let auxRivers=listRiver.data;
            let groupTitle=null;
            let auxOptions='';
            auxRivers.forEach( (el,index) => {
                if(index===0){
                    groupTitle=el.cuenca;
                    auxOptions+=`<optgroup label="${el.cuenca}">`;
                    auxOptions+=`<option value="${el.id}">${el.name_lake}</option>`;
                }else if(groupTitle===el.cuenca){
                    auxOptions+=`<option value="${el.id}">${el.name_lake}</option>`;
                }else{
                    auxOptions+=`</optgroup>`;
                    groupTitle=el.cuenca;
                    auxOptions+=`<optgroup label="${el.cuenca}">`;
                    auxOptions+=`<option value="${el.id}">${el.name_lake}</option>`;
                }

            });
            auxOptions+=`</optgroup>`;
            this.option_river=auxOptions;
            // console.log(this.option_river);
            this.list_river=listRiver.data;
            this.list_clima=listcl.data;
        },
        mSelectSector(){
            // aqui indicamos la descripcion del sector
            // this.sector_select=
            console.log(this.sector_select);
            this.read_lake.sector_id=this.sector_select.id_sector;
        },
        mSelectRiver(){
            // console.log(this.lake_select_aux);
            // // aqui buscar en el array
            // console.log(this.list_river[0]);
            let auxcode=this.lake_select_aux;
            let ind_aux=this.list_river.findIndex((val, index)=> val.id == auxcode);
            // console.log(ind_aux);
            // console.log(this.list_river.findIndex((val, index)=> val.id === auxcode));
            this.lake_select=this.list_river[ind_aux];
            // console.log(this.lake_select);
            this.mSelectRiverListSector();
        },
        async mSelectRiverListSector(){
            this.list_sector=[];
            // console.log(this.sector_register_edit.id_sector.id_sector);
            // this.sector_register_edit.id_sector.id_sector=0;
            // console.log(this.sector_register_edit.id_sector.id_sector);
            let r_sector=await axios.get(`getSectorRegister/${this.lake_select.id}?api_token=${Vue.auth.getToken()}`);
            console.log(r_sector);
            this.list_sector=r_sector.data;
        },
        activeModal(e){
            $(`#${e}`).modal('show');
        },
        inactiveModal(e){
            $(`#${e}`).modal('hide');
        }
    },
    computed:{
        cDtsUser(){
            return this.$store.getters.getUserState;
        },
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/river/readRiver.vue